import request from "@/api/request";

export function login() {}

export function getLoggedUserInfo() {
  return request({
    url: "/ucUser/getLoggedUserInfo",
    method: "get",
  });
}

export function getUserTodoCount() {
  return request({
    url: "/workTodo/getUserTodoCount",
    method: "post",
  });
}

export function listAllUser(param) {
  return request({
    url: "/user/listAll",
    method: "post",
    data: JSON.stringify(param),
  });
}

export function infoCodeExtraction(account) {
  return request({
    url: "/user/infoCodeExtraction",
    method: "post",
    data: { account },
  });
}

export function setIsNeed2faWeb(isNeedTfa, otp) {
  return request({
    url: "/user/setIsNeed2faWeb",
    method: "post",
    data: { isNeedTfa, otp },
  });
}

export default {
  page(param) {
    return request({
      url: "/user/page",
      method: "post",
      data: param,
    });
  },
  save(param) {
    return request({
      url: "/user/save",
      method: "post",
      data: param,
    });
  },
  delAll(ids) {
    return request({
      url: `/user/deleteByIds?ids=${ids}`,
      method: "delete",
    });
  },
  detail(id) {
    return request({
      url: `/user/detail?id=${id}`,
      method: "post",
    });
  },
  setDefaultPost(id) {
    return request({
      url: `/user/setDefaultPost?id=${id}`,
      method: "post",
    });
  },
  userPostPage(param) {
    return request({
      url: "/user/userPostPage",
      method: "post",
      data: param,
    });
  },
  userRolePage(param) {
    return request({
      url: "/user/userRolePage",
      method: "post",
      data: param,
    });
  },
  delUserPost(id) {
    return request({
      url: `/user/delUserPost?id=${id}`,
      method: "delete",
    });
  },
  delUserRole(id) {
    return request({
      url: `/user/delUserRole?id=${id}`,
      method: "delete",
    });
  },
  userBindRole(param) {
    return request({
      url: `/user/bindRole`,
      method: "post",
      data: param,
    });
  },
  userBindPost(param) {
    return request({
      url: `/user/bindPost`,
      method: "post",
      data: param,
    });
  },
  //删除用户岗位绑定
  delUserPostOrg(id) {
    return request({
      url: `/user/delUserPost?id=${id}`,
      method: "delete",
    });
  },
  //删除用户角色绑定
  delUserRoleOrg(id) {
    return request({
      url: `/user/delUserRole?id=${id}`,
      method: "delete",
    });
  },
  modifyPassword(param) {
    return request({
      url: `/user/modifyPassword`,
      method: "post",
      data: param,
    });
  },
  resetPassword(param) {
    return request({
      url: `/user/resetPassword`,
      method: "post",
      data: { id: param },
    });
  },
  bindRoleAndInfoCode(param) {
    return request({
      url: `/user/bindRoleAndInfoCode`,
      method: "post",
      data: param,
    });
  },
};
